import axios from "axios";
// @ts-ignore
window.axios = axios;
export default axios;
